import './gallery-mosaic.scss';

/**
 * version    1.0
 * class      ImmobileGalleryMosaic
 * classdesc  Component that manage the gallery mosaic
 */
export class ImmobileGalleryMosaic {}
